// Import the plugins
const Uppy = require("@uppy/core");
const Dashboard = require("@uppy/dashboard");
const XHRUpload = require("@uppy/xhr-upload");


require("@uppy/core/dist/style.css");
require("@uppy/dashboard/dist/style.css");

(function () {
    const uppy = {
        /**
         *
         */
        el: null,

        uppy: {
            debug: true,
            locale: require("@uppy/locales/lib/es_ES"),
            restrictions: {
                maxFileSize: 2000000,
                minNumberOfFiles: 1,
                allowedFileTypes: ["application/pdf"],
            },
        },

        /**
         *
         */
        dashboard: {
            metaFields: [
                {
                    id: "name",
                    name: "Name",
                    placeholder: "Nombre del Archivo",
                },
            ],
            proudlyDisplayPoweredByUppy: false,
            target: "#uppy",
            inline: true,
            replaceTargetContent: true,
            showProgressDetails: true,
            note:
                "Los documentos deberán ser en formato PDF y tamaño máximo de 2mb",
            height: 500,
            browserBackButtonClose: true,
        },

        /**
         *
         */
        xhr: {
            limit: 10,
            endpoint: "/user/document/store",
            headers: {
                "X-CSRF-Token": $('meta[name="csrf-token"]').attr(
                    "content"
                ),
            },
        },

        /**
         *
         */
        init: function () {
            const uppy = document.getElementById("uppy");

            if (!uppy) return;

            this.build(uppy);
        },

        /**
         *
         */
        build() {
            this.el = new Uppy(this.uppy);
            this.el.use(Dashboard, this.dashboard);
            this.el.use(XHRUpload, this.xhr);
            this.el.on("upload-success", this.reload);
        },

        reload() {
            location.reload();
        }
    };

    uppy.init();
})();
